import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import HeaderThin from 'app/components/layout/HeaderThin';
import CardGroup from 'app/components/general/CardGroup';
import Button from 'app/components/general/Button';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';
import Isvg from 'react-inlinesvg';
import SectionGroup from 'app/components/general/SectionGroup';

import SchemaForm from 'app/components/general/SchemaForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import organisationSizes from 'app/utils/static/organisationSizes';

import { getStripeSessions } from 'app/ducks/stripeSessions/selectors';
import { getOrganisations } from 'app/ducks/organisations/selectors';
import { getOrganisationSubscriptions } from 'app/ducks/organisationSubscriptions/selectors';

import * as stripeSessionActions from 'app/ducks/stripeSessions/actions';
// import SelectPlan from '../SelectPlan';
import PlanSummary from './PlanSummary';

interface IManageBillingProps {
  actions: any;
  organisations: any;
  stripeSessions: any;
  organisationSubscriptions: any;
}

interface IManageBillingState {
  originalFormData: any;
  formData: any;
  changed: boolean;
  saved: boolean;
  errors: any;
  stage: string;
}

const formSchema = {
  type: 'object',
  required: ['size'],
  properties: {
    size: {
      type: 'object',
      title: 'Size',
      options: organisationSizes,
      inputType: 'select',
    },
  },
};

const uiSchema = {
  size: { 'ui:field': 'select', classNames: 'col' },
};
export function selector(state) {
  return {
    stripeSessions: getStripeSessions(state),
    organisations: getOrganisations(state),
    organisationSubscriptions: getOrganisationSubscriptions(state),
  };
}

const actionCreators = _.merge(stripeSessionActions);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  } as any),
)
export default class ManageBilling extends React.Component<IManageBillingProps, IManageBillingState> {
  static defaultProps: IManageBillingProps = {
    actions: undefined,
    stripeSessions: undefined,
  };

  state: IManageBillingState = {
    originalFormData: {},
    formData: {
      size: _.find(organisationSizes, (size) => size.id === 'small'),
    },
    changed: false,
    saved: false,
    errors: {},
    stage: 'size',
  };

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.changed) {
      return {
        ...prevState,
        errors: nextProps.errors,
      };
    }
    return null;
  }

  componentDidMount(): void {
    if (_.isEmpty(this.props.organisationSubscriptions.currentOrganisationSubscription) && !this.props.organisations.currentOrganisation?.hasActiveSubscriptionPlan) {
      history.push('/billing/select-plan');
    }
    if (this.props.organisations.currentOrganisation?.activeOrganisationSubscription) {
      this.props.actions.getOrganisationSubscription(this.props.organisations.currentOrganisation?.activeOrganisationSubscription.id);
    }
  }


  isValid = (): boolean => _.isEmpty(this.state.errors) && this.state.changed;

  handleChange = (e): void => {
    const changed = this.state.originalFormData !== e.formData;
    this.setState(() => ({
      formData: e.formData,
      errors: [],
      changed,
    }));
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleSubmit = (e): void => {
    if (this.isValid()) {
      // const payload = {
      //   name: this.state.formData.name,
      //   friendlyCode: this.state.formData.friendlyCode,
      //   organisation: {
      //     id: this.props.organisations.currentOrganisationId,
      //   },
      // };

      // this.props.actions.createCompetition(payload);
    }
    this.setState({ changed: false });
  };

  handleSize = (e): void => {
    this.setState({ stage: 'select' });
  }


  handleStripeBilling = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.actions.createStripeSession({});
  }

  render(): React.ReactNode {
    const activeSubscription = this.props.organisationSubscriptions.currentOrganisationSubscription;
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              divider
              title="Billing"
            // infoText="Reports are updated every 15 minutes."
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-lg-8 col-xl-6">
            <SectionGroup title="Your Plan">
              <div className="row">
                <div className="col">
                  <PlanSummary subscription={activeSubscription} />
                </div>
              </div>
              <div className="row margin-top">
                <div className="col">
                  <Button className="btn btn-2" noLoading onClick={this.handleStripeBilling}>Manage & View Invoices</Button>
                </div>
              </div>
            </SectionGroup>
          </div>
        </div>
      </div>
    );
  }
}
